import { Routes } from '@angular/router';
import { authGuard } from '../lib-shared/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'home',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/home/home.component').then(c => c.HomeComponent)
  },
  {
    path: 'matriz-riesgos',
    canActivate: [authGuard],
    loadChildren: () => import('./pages/matriz-riesgos/matriz-riesgos.module').then(m => m.MatrizRiesgosModule)
  },
  {
    path: 'file-upload-demo',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/file-upload-demo/file-upload-demo.component').then(c => c.FileUploadDemoComponent)
  },
  {
    path: 'privado/principal',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/redirect/principal-redirect.component').then(c => c.PrincipalRedirectComponent)
  },
  {
    path: 'privado/principal/vigilancia',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/redirect/vigilancia-redirect.component').then(c => c.VigilanciaRedirectComponent)
  },
  { path: '', redirectTo: '/login', pathMatch: 'full' }
];
